import { render, staticRenderFns } from "./ShowsShow.vue?vue&type=template&id=c28edea4"
import script from "./ShowsShow.vue?vue&type=script&lang=js"
export * from "./ShowsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports